import { render, staticRenderFns } from "./AccisureCustomerImportForm.vue?vue&type=template&id=0f6e70c4"
import script from "./AccisureCustomerImportForm.vue?vue&type=script&lang=js"
export * from "./AccisureCustomerImportForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports